/**
 * List component for transactions, managing list content and implementing event handler
 *
 * Properties:
 *
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useState, useEffect } from "react";
import Popup from "../../../components/Popup";
import { $, _ } from "../../../../../vendor";
import { useSelector } from "inbooma-api";
import CheckOutView from "./CheckOutView";
import ReservationItem from "./ReservationItem";
import ShowLogDialog from "./ShowLogDialog";
import ShowTrackingsDialog from "../../facilities/components/ShowTrackingsDialog";

const ReservationsList = (props) => {
  const currentUrl = new URL(window.location.href);
  const {
    reservations,
    locations,
    dispatch,
    checkout,
    setCheckout,
    _exchangeLabel,
    filterChangedHandle,
    filter,
    setFilter,
    sort,
    setSort,
    setCheckInCheckOut,
    checkInCheckOut,
    _key,
    setKey,
    params,
    openChangeLog,
    showNotification,
    returnUrl,
  } = props;
  const _user = useSelector((state) => state.users_data.user);
  const [showLogDialog, setShowLogDialog] = useState(false);
  const [tempReservation, setTempReservation] = useState(null);
  const [checkoutReservation, setCheckoutReservation] = useState(
    checkout && reservations.length === 1 ? reservations[0] : null,
  );
  const [checkoutCheckin, setCheckoutCheckin] = useState(null);
  const [popup, setPopup] = useState({
    open: false,
    linkText: "",
    link: "",
  });
  const onShowLog = (reservation) => {
    setTempReservation(reservation);
    setShowLogDialog(true);
  };

  useEffect(() => {
    if (_user.success === "") return;

    if (_user.success === true) {
      let info =
        typeof _user.data.first_name !== "undefined" && _user.data.first_name !== null
          ? _user.data.first_name
          : "";
      info +=
        typeof _user.data.last_name !== "undefined" && _user.data.last_name !== null
          ? " " + _user.data.last_name
          : "";

      // show popup with user info and link to user profile
      setPopup({
        left: popup.left,
        top: popup.top,
        open: true,
        text: popup.text,
        link: "users/" + _user.data.id + "?path=/reservations/reservationsList",
        linkText: info.length === 0 ? _user.data.id : info,
      });
    } else {
      console.log("Failed to fetch user");
    }
  }, [_user]);

  if (_key !== null) {
    let selector = "[key=" + _key + "]";
    if ($(selector).length >= 1) {
      $("html,body").scrollTop($(selector).offset().top - 10);
    }
  }

  const popupCloseHandler = () => {
    setPopup({
      ...popup,
      open: false,
    });
  };
  const handleCloseDialog = () => {
    setShowLogDialog(false);
    setTempReservation(null);
  };

  return (
    <>
      <div
        className="inb-c-listing off-canvas-content"
        id="inb-c-main-orders"
        style={{ minHeight: "1150px", paddingTop: "10px" }}
      >
        {showLogDialog && (
          <ShowLogDialog
            handleCloseDialog={handleCloseDialog}
            reservation={tempReservation}
            dispatch={dispatch}
          />
        )}
        {!checkout &&
          typeof reservations !== "undefined" &&
          reservations.length > 0 &&
          reservations.map((reservation, index) => {
            return (
              <>
                <ReservationItem
                  reservation={reservation}
                  index={index}
                  dispatch={dispatch}
                  _exchangeLabel={_exchangeLabel}
                  setCheckout={setCheckout}
                  checkout={checkout}
                  setCheckoutCheckin={setCheckoutCheckin}
                  setCheckoutReservation={setCheckoutReservation}
                  setFilter={setFilter}
                  filter={filter}
                  setNKey={setKey}
                  sort={sort}
                  setSort={setSort}
                  _key={_key}
                  locations={locations}
                  setPopup={setPopup}
                  popup={popup}
                  currentUrl={currentUrl}
                  filterChangedHandle={filterChangedHandle}
                  showNotification={showNotification}
                  params={params}
                  openChangeLog={openChangeLog}
                  onShowLog={onShowLog}
                />
              </>
            );
          })}

        {checkout && checkoutReservation !== null && (
          <CheckOutView
            reservation={checkoutReservation}
            checkin={checkoutCheckin}
            returnUrl={returnUrl}
            dispatch={dispatch}
            filter={filter}
            filterChangedHandle={filterChangedHandle}
            setCheckout={setCheckout}
            _key={_key}
            setNKey={setKey}
            setFilter={setFilter}
            sort={sort}
            setSort={setSort}
          />
        )}
        {popup.open === true && (
          <Popup
            left={popup.left}
            top={popup.top}
            linkText={popup.linkText}
            text={popup.text}
            link={popup.link}
            onCloseHandler={popupCloseHandler}
          />
        )}
      </div>
    </>
  );
};
export default ReservationsList;
